import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Card, CardBody, Input, Row, Col, Label } from "reactstrap";
import ConfirmModal from "../../components/common/ConfirmModal";
import DataTable from "../../components/common/DataTable";
import PageHeader from "../../components/common/PageHeader";
import { getExpensesRequest } from "../../redux/expense/actions";
import { api, isActionPermitted , getFormatDate, USER_TYPES, DB_FORMAT, getFormatOnlyDate } from "../../util";
import moment from "moment/moment";
import { getSaloonsRequest } from "../../redux/saloons/actions";

const ListExpense = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { expenses, count, loading } = useSelector((state) => state.expenses);
  const { permissions , accountId } = useSelector((state) => state.user);
  const { saloons } = useSelector((state) => state.saloons);
  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [paginationConfig, setPaginationConfig] = useState({
    page: 1,
    limit: 10,
    filter: {
      purpose: "",
      saloon: "",
      from: moment().startOf('month').format(DB_FORMAT.DATE),
	    to: moment().endOf('month').format(DB_FORMAT.DATE),
    },
    sort: "date",
  });

  useEffect(() => {
    if (isActionPermitted("expenses", "read", permissions)) {
      dispatch(getExpensesRequest(paginationConfig));
      dispatch(getSaloonsRequest());
    }
  }, [paginationConfig, permissions]);

  const deleteExpense = async (id) => {
    try {
      const response = await api.delete("/expenses/" + id);
      if (response.status === 200) {
        if (isActionPermitted("expenses", "read", permissions)) {
          dispatch(getExpensesRequest(paginationConfig));
        }
        toast.success(response?.data?.message || response.message);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || error.message);
    }
  };

  const onSearchChange = ({ target }) => {
    const { value } = target;
    const pc = paginationConfig;
    pc.filter.name = value;
    setPaginationConfig({ ...pc,  page: 1, limit: 10 });
  };

  const onDateRangeChange = ({ target }) => {
	  const { name, value } = target;
	  let pc = paginationConfig;
	  if (name === "from") {
      pc.filter[name] = (value !== "" ? moment(value).format(DB_FORMAT.DATE) : null);
      setStartDate((value !== "" ? moment(value).format(DB_FORMAT.DATE) : null));
    } else {
      pc.filter[name] = (value !== "" ? moment(value).format(DB_FORMAT.DATE) : null);
      setEndDate((value !== "" ? moment(value).format(DB_FORMAT.DATE) : null));
    }
	  setPaginationConfig({ ...pc, page: 1, limit: 10 });
  };

  const [startDate , setStartDate] = useState(paginationConfig.filter.from);
  const [endDate , setEndDate] = useState(moment().format(DB_FORMAT.DATE));
  const user = useSelector((state) => state.user);
  
  useEffect(() => {
    const options = [];
    if(saloons && saloons?.length > 0) {
      saloons.map((_ , index) => (
        options.push({"value" : _.Saloon.id , "label" : _.Saloon.name})
      ))
    }
  } , [saloons]);

  return (
    <React.Fragment>
      <PageHeader title="Expenses" addBtnUrl="/expenses/add" />
      <Card>
        <CardBody>
          <Row className="gy-3 gx-3">
          {user.role === USER_TYPES.SUPER_ADMIN && (
          	<Col xl={3} md={3} sm={12} xs={12}>
                  <Label>Location</Label>
                  <Input caret type="select" name="location" value={paginationConfig.filter.saloon}
                      onChange={(e) => {
                      let x = paginationConfig;
                      x.filter.saloon = e.target.value;
                      setPaginationConfig({ ...x,  page: 1, limit: 10 });
                      }}
                      >
                      <option value={""}>All Location</option>
                      {saloons.map((_, index) => (
                      <option key={_.id} value={_.Saloon.id}>
                          {_.Saloon.name}{_.Saloon.location && _.Saloon.location != null && (<> - {_.Saloon.location}</>)}
                      </option>
                      ))}
                  </Input>
              </Col>
          )}
            {/* 
            <Col xl={3} md={3} sm={12} xs={12} className="d-none">
              <Label>Purpose</Label>
              <Input
                value={paginationConfig.filter.purpose}
                type="search"
                placeholder="Search Purpose"
                role="search"
                aria-roledescription="search for purpose"
                autoFocus
                onChange={onSearchChange}
            />
            </Col>
            */}
            <Col xl={3} md={3} sm={6} xs={6}>
              <Label>From</Label>
              <Input name="from" onChange={onDateRangeChange} value={moment(paginationConfig.filter.from).format(DB_FORMAT.DATE)} max={endDate}  type="date" />
            </Col>
            <Col xl={3} md={3} sm={6} xs={6}>
              <Label>To</Label>
              <Input min={startDate} onChange={onDateRangeChange} name="to" value={moment(paginationConfig.filter.to).format(DB_FORMAT.DATE)} type="date"/>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <DataTable
        isPagination
        count={count}
        loading={loading}
        paginationConfig={paginationConfig}
        setPaginationConfig={setPaginationConfig}
        data={expenses}
        columns={[
          { Header: "Shop Name", accessor: "Saloon.name" },
          { Header: "Purpose", accessor: "purpose" },
          { Header: "Date", accessor: "date", Cell: ({ row }) => {
              return `${ ( row.original.date ? getFormatOnlyDate(row.original.date) : '' )}`;
          	} 
          },
          { Header: "Amount", accessor: "amount" },
          {
              Header: "Date and Time",
              accessor: "createdAt",
              Cell: ({ row }) => {
                  return `${getFormatDate(row.original.createdAt)}`;
              },
          },
          {
            Header: "Actions",
            accessor: "actions",
            width: "10%",
            Cell: ({ row }) => {
              return (
                <div className="d-flex gap-2">
                  {isActionPermitted("expenses", "edit", permissions) && (
                    <Button
                      onClick={() => navigate(`/expenses/${row.original.id}`)}
                    >
                      <i className="bi bi-pencil-square"></i>
                    </Button>
                  )}
                  {isActionPermitted("expenses", "delete", permissions) && (
                    <Button
                      color="danger"
                      onClick={() => {
                        setDeleteId(row.original.id);
                        setShowDeleteModal(true);
                      }}
                    >
                      <i className="bi bi-trash"></i>
                    </Button>
                  )}
                  
                </div>
              );
            },
          },
        ]}
      />

      {showDeleteModal && (
        <ConfirmModal
          isOpen={showDeleteModal}
          setIsOpen={setShowDeleteModal}
          onOk={() => deleteExpense(deleteId)}
          onCancel={() => {
            setDeleteId(null);
            setShowDeleteModal(false);
          }}
        />
      )}
    </React.Fragment>
  );
};

export default ListExpense;
